// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"7912": "bf821548","8457": "790bc4bf","896": "dae2d6db","9023": "e9a9f004",}[chunkId] + ".css"
}